<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="text-center"><i class="fas fa-rocket card-start-icon"></i></p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      <div class="card-data">
        <p v-if="node.data.triggerKeyword" class="text-center text-truncate text-muted mb-1 triggerKeywords" data-toggle="tooltip" :title="node.data.triggerKeyword">
          {{ node.data.triggerKeyword }}
        </p>
      </div>

      <div class="card-sockets">
        <div class="output text-right triggerOutputCircle" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
          <div class="output-title">{{output.name}}</div>
          <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import { templateComponentMethods } from '../../functions/utils'

export default {
  name: 'TriggerTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  methods: {
    ...templateComponentMethods,
  },

  updated() {
    $('[data-toggle="tooltip"]').tooltip()
  },

  beforeDestroy() { // eslint-disable-line
    $('[data-toggle="tooltip"]').tooltip('dispose')
  },  
}
</script>

<style scoped>
.card-start-icon { font-size: 20px;margin-left: 0 !important;margin-top:20px !important; }
.card_data_body { border-top:0 !important;padding-top:0 !important;padding-bottom:0 !important;}
.xit-fb-template {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  padding: 0;
  margin: 0;
  min-width: 0;
}
.triggerKeywords { font-size:12px;}

.triggerOutputCircle .socket {
  position: absolute;
  top: calc(50% - 5px);
  right: 10px;
}
</style>